import { render, staticRenderFns } from "./MoldAllocated.vue?vue&type=template&id=c680a2d6&"
import script from "./MoldAllocated.vue?vue&type=script&lang=js&"
export * from "./MoldAllocated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports